module.exports = __webpack_public_path__ + "img/arrow-right-grey.9965e9c6.svg";